export const SET_ORDER_LIST = 'SET_ORDER_LIST'
export const SET_MYGOODS_LIST = 'SET_MYGOODS_LIST'
export const SET_GOODS_LIST = 'SET_GOODS_LIST'
export const SET_STORAGE_USERINFO = 'SET_STORAGE_USERINFO'
export const SET_LOGINSTATUS = 'SET_LOGINSTATUS'
export const SET_USER_INFO='SET_USER_INFO'
//商品授权
export const SET_SHOPID_INFO='SET_SHOPID_INFO'
export const SET_LAZADA_PROCESSED_ORDER="SET_LAZADA_PROCESSED_ORDER"
export const SET_ITEM_TRUE='SET_ITEM_TRUE'
export const SET_ORDER_FINISH='SET_ORDER_FINISH'
export const SET_ORDER_UNPAID='SET_ORDER_UNPAID'
export const SENT_PPT='SENT_PPT'
export const READY_TO_SHIP='READY_TO_SHIP'
export const ALL_ORDERS='ALL_ORDERS'
export const SET_STORAGE_TTP='SET_STORAGE_TTP'
export const GET_SUCCESSED_DATA='GET_SUCCESSED_DATA'
export const SET_SISTEM_ALL_STORE='SET_SISTEM_ALL_STORE'
export const GET_QUENTITY_OUT_OF_STOCK_01='GET_QUENTITY_OUT_OF_STOCK_01'
export const SET_INTN="SET_INTN"
export const UPDATE_ALLORDERLIST='UPDATE_ALLORDERLIST'
export const GET_ORDER_LIST_SHIPPED='GET_ORDER_LIST_SHIPPED'
export const CANCELLED='CANCELLED'
export const TO_RETURN='TO_RETURN'
export const TO_CONFIRM_RECEIVE='TO_CONFIRM_RECEIVE'
export const GET_UNPROCESS_ORDER='GET_UNPROCESS_ORDER' 
export const SET_ORDERLIST_NULL='SET_ORDERLIST_NULL'
export const SET_WAREHOUSE_INFO='SET_WAREHOUSE_INFO'
export const GET_DEAL_OREDR='GET_DEAL_OREDR'
export const GET_AUDITED_ORDER='GET_AUDITED_ORDER'
export const DELET_UNPROCESS_ORDER='DELET_UNPROCESS_ORDER'
export const GET_DEAL_ORDER='GET_DEAL_ORDER'
export const GET_COMPLETEED_ORDER='GET_COMPLETEED_ORDER'
export const CHOOSE_SHOPID='CHOOSE_SHOPID'
export const GET_RETURN_MANAGEMTNT='GET_RETURN_MANAGEMTNT'
export const GET_TTP_PPO='GET_TTP_PPO'
export const AUDITOR_ORDER_CHOOSE='AUDITOR_ORDER_CHOOSE'
export const COMPLETED_ORDER_CHOOSE='COMPLETED_ORDER_CHOOSE'
export const CHOOSE_SHOPID_TTP='CHOOSE_SHOPID_TTP'
export const CHOOSE_SHOPID_OOP='CHOOSE_SHOPID_OOP'
export const GO_TO_SEARCH='GO_TO_SEARCH'
export const GO_TO_SEARCH_DEALOURDER='GO_TO_SEARCH_DEALOURDER'
export const SHOW_LOADING='SHOW_LOADING'
export const GO_TO_SEARCH_PENDING='GO_TO_SEARCH_PENDING'
export const SUCCESS_GET_DATA='SUCCESS_GET_DATA'
export const SUCCESS_GET_DATA_OPEN='SUCCESS_GET_DATA_OPEN'
export const GET_QUESTION_ORDER='GET_QUESTION_ORDER'
export const GET_ORDER_LIST_PROBLEM='GET_ORDER_LIST_PROBLEM'
export const GO_TO_SEARCH_QUESTION='GO_TO_SEARCH_QUESTION'
export const QUESTION_ORDER_CHOOSE='QUESTION_ORDER_CHOOSE'
export const SET_REGISTOR_SUCCESS='SET_REGISTOR_SUCCESS'
export const SET_LOGIN_STATUS='SET_LOGIN_STATUS'
export const PENDING_TOTAL_COUNT='PENDING_TOTAL_COUNT'
export const UNPROCESS_TOTAL_COUNT='UNPROCESS_TOTAL_COUNT'
export const SHIPPED_TOTAL_COUNT='SHIPPED_TOTAL_COUNT'
export const PROBLEM_TOTAL_COUNT='PROBLEM_TOTAL_COUNT'
export const GET_RETURN_CHIRD_TOTAL_23="GET_RETURN_CHIRD_TOTAL_23"
export const SET_LAZADA_STATE_NULL='SET_LAZADA_STATE_NULL'
export const RETURN_TOTAL_ORDER='RETURN_TOTAL_ORDER'
export const IN_CANCEL_TOTAL_ORDER='IN_CANCEL_TOTAL_ORDER'
export const SET_ITEM_CHECKED_FALSE='SET_ITEM_CHECKED_FALSE'
export const SET_ITEM_CHECKED_TRUE='SET_ITEM_CHECKED_TRUE'
export const SET_PICKING_LIST='SET_PICKING_LIST'
export const SET_PICKING_NULL='SET_PICKING_NULL'
export const ININ_TRACKING_NO ='ININ_TRACKING_NO'
export const GET_ORDER_NUPRINT='GET_ORDER_NUPRINT'
export const GET_RETURN_ORDER='GET_RETURN_ORDER'
export const GET_RETURN_CHIRD_TOTAL_14="GET_RETURN_CHIRD_TOTAL_14"
export const GET_RETURN_CHIRD_TOTAL_17="GET_RETURN_CHIRD_TOTAL_17"
export const GET_RETURN_CHIRD_TOTAL_15="GET_RETURN_CHIRD_TOTAL_15"
export const GET_RETURN_CHIRD_TOTAL_16="GET_RETURN_CHIRD_TOTAL_16"
export const GET_RETURN_CHIRD_TOTAL_18="GET_RETURN_CHIRD_TOTAL_18"
export const GET_RETURN_CHIRD_TOTAL_20="GET_RETURN_CHIRD_TOTAL_20"
export const GET_RETURN_CHIRD_TOTAL_22="GET_RETURN_CHIRD_TOTAL_22"
export const GET_RETURN_CHIRD_TOTAL_21="GET_RETURN_CHIRD_TOTAL_21"
export const GET_STORE_ALERDAY_PRINT="GET_STORE_ALERDAY_PRINT"
export const GET_LAZADA_SHOP='GET_LAZADA_SHOP'
export const GET_TTO_CCP='GET_TTO_CCP'
export const REMOVE_STATE_R='REMOVE_STATE_R'
export const KEEP_CHOOSED_ITEM="KEEP_CHOOSED_ITEM"
export const SET_SECONDE_PICKTIME='SET_SECONDE_PICKTIME'
export const INIT_DATA="INIT_DATA"
// mygoods
export const GET_MYGOODS_TOTAL="GET_MYGOODS_TOTAL"
export const  ADD_STORE_ITEMS="ADD_STORE_ITEMS"
export const GET_CURCODE_LIST="GET_CURCODE_LIST"
export const SET_SUCCESS_ERROR_NULL="SET_SUCCESS_ERROR_NULL"
export const SET_LOGISTIC_FALSE='SET_LOGISTIC_FALSE'

//userStoreItems
export const GET_USER_STORE_LIST="GET_USER_STORE_LIST"
export const GET_SUCCESS_DATA="GET_SUCCESS_DATA"
export const GET_ERROR_DATA="GET_ERROR_DATA"
export const SET_ITEMS_COUNT='SET_ITEMS_COUNT'
export const GET_CURCODE_LIST_NULL='GET_CURCODE_LIST_NULL'
export const SET_BIND_ITEMS_LIST='SET_BIND_ITEMS_LIST'
export const REMOVE_ITEM="REMOVE_ITEM"
export const REMOVE_BIND_ITEM='export const REMOVE_BIND_ITEM'
export const SET_COUNT_QUEHUO='SET_COUNT_QUEHUO'
export const DELET_HAS_CLAIM="DELET_HAS_CLAIM"
export const SET_HAS_PRINTED="SET_HAS_PRINTED"
export const GET_PURCHASE_ORDER='GET_PURCHASE_ORDER'
export const GET_PURCHASE_TATAL='GET_PURCHASE_TATAL'
export const GET_LOGISTICS_INFO='GET_LOGISTICS_INFO'
export const SET_TTP='SET_TTP'

export const GET_CANCEL_TOTAL_24="GET_CANCEL_TOTAL_24"
export const GET_CANCEL_TOTAL_25="GET_CANCEL_TOTAL_25"
export const GET_CANCEL_TOTAL_26="GET_CANCEL_TOTAL_26"
export const GET_CANCEL_TOTAL_27="GET_CANCEL_TOTAL_27"
export const GET_CANCEL_TOTAL_28="GET_CANCEL_TOTAL_28"
export const GET_CANCEL_TOTAL_29="GET_CANCEL_TOTAL_29"
export const FAST_PRINT="FAST_PRINT"
export const TARGET_ALL='TARGET_ALL'
export const GET_DATA_STATUS='GET_DATA_STATUS'
export const GET_DATA_STATUS_COLSE='GET_DATA_STATUS_COLSE'
export const SWITCH_LANG='SWITCH_LANG'
export const GET_LAZADA_LIST='GET_LAZADA_LIST'
export const GET_ORDER_LIST='GET_ORDER_LIST'
export const GET_ORDER_LIST_UNPROCESSED='GET_ORDER_LIST_UNPROCESSED'
export const SET_REGISTOR_FALSE='SET_REGISTOR_FALSE'
export const GET_TTP='GET_TTP'
export const REMOVE_STATE_T="REMOVE_STATE_T"
export const REMOVE_STATE_P="REMOVE_STATE_P"
export const SET_REPLENISHMENT_PREIOD='SET_REPLENISHMENT_PREIOD'
export const GET_ORDER_LIST_PENDING='GET_ORDER_LIST_PENDING'
export const GET_QUENTITY_OUT_OF_STOCK='GET_QUENTITY_OUT_OF_STOCK'
export const SET_ITEMS='SET_ITEMS'
export const SET_HAS_PRINTED_READY='SET_HAS_PRINTED_READY'
export const  RESET_SECOND_PASSWORD='RESET_SECOND_PASSWORD'
export const DELET_HAS_CLAIM_ALL='DELET_HAS_CLAIM_ALL'
export const SET_PROCESSED_ORDER_LIST="SET_PROCESSED_ORDER_LIST"
export const SET_FLAGS='SET_FLAGS'
export const UPDATA_PAGE="UPDATA_PAGE"
export const GET_UNSALABLE_DATA="GET_UNSALABLE_DATA"